import axios from 'axios'
import Vue from 'vue'
import { URLS } from '../../util/urls'
import tools from '../../util/tools'
import debugHelper from '../../util/debug'
import dbHelper from '../../util/db'
import APP_CONFIG from '../../config/App'

const state = {
  /**
   * 登陆成功并存有Token信息
   */
  loginSuccess: null,
  /**
   * 登陆用户的个人信息
   */
  userInfo: null,
  failure: null,
  /**
   * 手机号信息
   */
  phoneNumber: '',
  /**
   * 登录密码信息
   */
  password: '',
  /**
   * 验证码信息
   */
  regcode: '',
  /**
   * 当前租户id
   */
  tid: '',
  /**
   * 当前租户显示名
   */
  tname: '',
  /**
   * 当前租户logo
   */
  tlogo: '',
  /**
   * 当前租户服务的服务API
   */
  tserviceAPI: '',
  /**
   * 当前租户服务版本
   */
  tserviceVersion: '',

  // 获取验证码等待计时
  regcodeWaitingTime: 0, // 60秒计时
}

const getters = {
  // 获取登录账号信息
  getAccountInfo: state => {
    if (state.loginSuccess != null) {
      return state.loginSuccess
    }
  },
  getAccountID: state => {
    if (state.loginSuccess != null) {
      return state.loginSuccess.aid
    }
  },
  getAccountToken: state => {
    if (state.loginSuccess != null) {
      return state.loginSuccess.token
    }
  },
  getAccountTenants: state => {
    if (state.loginSuccess != null) {
      return state.loginSuccess.tenants
    }
  },
  getAccountTenantKeys: state => {
    if (state.loginSuccess != null) {
      let tenantKeys = []
      state.loginSuccess.tenants.forEach(tenant => {
        tenantKeys.push(tenant.mobileAppLicense.entKey.key)
      })
      return tenantKeys
    }
  },
  getTokenExpire: state => {
    if (state.loginSuccess != null) {
      return state.loginSuccess.expire
    }
  },
  getCurrentTenantID: state => {
    return state.tid
  },
  getCurrentTenantName: state => {
    return state.tname
  },
  getCurrentTenantLogo: state => {
    return state.tlogo
  },
  getCurrentTenantServiceAPI: state => {
    return state.tserviceAPI
  },
  getCurrentTenantServiceVersion: state => {
    return state.tserviceVersion
  },
  isEDS16: state => {
    return state.tserviceVersion ? state.tserviceVersion.match(APP_CONFIG.RgxEDS16_Version) : false
  },
  getUserOID: state => {
    if (state.userInfo != null) {
      return state.userInfo.data.fid
    }
  },
  getUserName: state => {
    if (state.userInfo != null) {
      return state.userInfo.data.name
    }
  },
  // 获取登录用户信息
  getUserInfo: state => {
    if (state.userInfo != null) {
      return state.userInfo.data
    }
  },
  // 获取登录用户的角色
  getUserRoles: state => {
    if (state.userInfo != null) {
      // return state.userInfo.data.roles
      return state.tid == '' ? [{ roleID: 'others', name: '其他' }] : [{ roleID: 'users', name: '用户' }]
    }
  },
  // 获取登录用户的角色权限
  getUserRoleRights: state => {
    if (state.userInfo != null) {
      return state.userInfo.data.rights
    }
  },
  getPhoneNumber: state => {
    if (state.phoneNumber != '') {
      return state.phoneNumber
    }
  },
  getRegcode: state => {
    if (state.regcode != '') {
      return state.regcode
    }
  },
  getPassword: state => {
    if (state.password != '') {
      return state.password
    }
  },
  getRegcodeWaitingTime: state => {
    return state.regcodeWaitingTime
  },
}

const actions = {
  /**
   * 获取用户Token
   */
  fetchAuthToken: ({ commit }, params) => {
    console.log('调试代码')
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: URLS.EDS_LOGIN_URL,
        data: params.data,
        timeout: APP_CONFIG.timeout,
        headers: {
          'Content-Type': 'application/json',
        }
      })
        .then(resp => {
          debugHelper.log(resp)
          if (!params.noCommit) {
            commit('setLoginSuccess', { value: resp.data })
          }
          resolve(resp.data)
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'login:'
          tools.showTips(params.vm, err)
          reject()
          return
        })
    })
  },
  /**
   * 刷新用户Token过期信息 
   */
  refreshAuthToken: ({ commit }, params) => {
    debugHelper.log(params)
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: URLS.EDS_LOGIN_REFRESH_URL,
        timeout: APP_CONFIG.timeout,
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          commit('setLoginSuccess', {
            value: resp.data
          })
          resolve()
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'login:'
          tools.showTips(params.vm, err)

          // 刷新token有错误时（例：网络不通），不清空token，不跳转登录页面
          if (err.response && err.response.data && (err.response.data.message == 'tenant access denied'
            || err.response.data.message == 'please switch to actual tenant'
            || err.response.data.message == 'incorrect Username or Password'
            || err.response.data.message == 'user password changed'
            || err.response.data.message == 'account not found'
            || err.response.data.message == 'signature is invalid')) {
            // 清租户信息
            dbHelper.remove('tid')
            dbHelper.remove('tname')
            // 清空localstorage里用户相关的数据，包含清token
            dbHelper.restore()
            params.vm.$router.replace({ name: 'pwdlogin' })
          } else {
            console.log('调试代码 refreshAuthToken error')
            params.vm.$router.replace({ name: 'networkerror', params: { err: err } })
          }
          // End Modify by ydr 2020-04-28
          reject()
          return
        })
    })
  },

  /**
   * 获取用户信息
   */
  fetchUserInfo: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: URLS.EDS_TENANTS_URL + '/' + params.tid + '/current-user',
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          commit('setUserInfo', { value: resp.data })
          resolve()
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'login:'
          tools.showTips(params.vm, err)

          // 若提示token无效，则跳转到登录页
          if (err.response && err.response.data && err.response.data.message == 'signature is invalid') {
            dbHelper.remove('tid')
            dbHelper.remove('tname')
            params.vm.$router.replace({ name: 'pwdlogin' })
          } else {
            console.log('调试代码 fetchUserInfo error')
            params.vm.$router.replace({ name: 'networkerror', params: { err: err } })
          }
          reject(err)
          return
        })
    })
  },

  updateUserPhone: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'put',
        url: URLS.EDS_AUTH_URL + '/update-phone',

        data: params.data,
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          commit('updateUserInfo', {
            value: params.data
          })
          resolve()
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'login:'
          tools.showTips(params.vm, err)
          reject()
          return
        })
    })
  },
  updateUserPwd: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: URLS.EDS_AUTH_URL + '/update-password',
        data: params.data,
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          resolve()
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'login:'
          reject(err)
          return
        })
    })
  },
}

const mutations = {
  setLoginSuccess: (state, payload) => {
    // state.loginSuccess = payload.value
    Vue.set(state, 'loginSuccess', payload.value)
    state.phoneNumber = payload.value.mobileNo || payload.value.email

    dbHelper.set('expire', state.loginSuccess.expire)
    dbHelper.set('token', state.loginSuccess.token)

    if (state.loginSuccess.tenants && state.loginSuccess.tenants.length > 0) {
      // 判断是否有本地存储且有效的租户信息
      var tid = dbHelper.get('tid') != null ? dbHelper.get('tid') : ''
      var currretnTenant = null
      var tenantsTemp = state.loginSuccess.tenants.filter((tenant) => tenant.id == tid)
      if (tenantsTemp && tenantsTemp.length > 0) {
        currretnTenant = tenantsTemp[0]
      }
      // 没有则默认选中第一个
      if (!currretnTenant) {
        currretnTenant = state.loginSuccess.tenants[0]
      }
      state.tid = currretnTenant.id
      state.tname = currretnTenant.name
      state.tlogo = currretnTenant.logo
      state.tserviceAPI = currretnTenant.serviceAPI
      state.tserviceVersion = currretnTenant.serviceVersion
      dbHelper.set('tid', state.tid)
      dbHelper.set('tname', state.tname)
    }
  },
  setCurrentTenant: (state, payload) => {
    state.tid = payload.tid
    state.tname = payload.tname
    state.tlogo = payload.tlogo
    state.tserviceAPI = payload.tserviceAPI
    state.tserviceVersion = payload.tserviceVersion
    dbHelper.set('tid', state.tid)
    dbHelper.set('tname', state.tname)
  },
  setUserInfo: (state, payload) => {
    console.log('代码调试')
    state.userInfo = payload.value
  },
  updateUserInfo: (state, payload) => {
    for (var tmp in payload.value) {
      state.userInfo.data[tmp] = payload.value[tmp]
    }
  },
  setPhoneNumber: (state, payload) => {
    state.phoneNumber = payload.value
  },
  setPassword: (state, payload) => {
    state.password = payload.value
  },
  setRegcode: (state, payload) => {
    state.regcode = payload.value
  },
  setRegcodeWaitingTime: (state, payload) => {
    state.regcodeWaitingTime = payload.value
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
